<div id="int-finances-main" class="w-full h-full">
  <app-internal-toolbar [title]="'internal.finances.title' | translate">
    @if (api.hasPermission('create_finances')) {
      <ng-container actions>
        <reactive-button
          [label]="'internal.finances.startInvoice' | translate"
          icon="receipt_long"
          variant="outlined"
          (onClick)="startInvoice()"
        ></reactive-button>

        <reactive-button
          [label]="'internal.finances.newTransaction' | translate"
          icon="add"
          variant="outlined"
          (onClick)="editTransaction()"
        ></reactive-button>
      </ng-container>
    }
  </app-internal-toolbar>

  <form [formGroup]="filterForm" class="transaction-filter m-2 p-4">

    <p-floatlabel variant="on" id="filter-reason">
      <p-iconfield>
        <input pInputText #reasonInput formControlName="reason" autocomplete="off" />
        @if (reasonInput.value) {
          <p-inputicon
            class="cursor-pointer m-auto"
            (click)="filterForm.patchValue({reason: null})"
          >
            <mat-icon>close</mat-icon>
          </p-inputicon>
        } @else {
          <div [style.width]="'28px'"></div>
        }
      </p-iconfield>
      <label>{{ 'internal.finances.transaction.reason' | translate }}</label>
    </p-floatlabel>

    @if (loadingUsers()) {
      <p-skeleton id="filter-user" width="13rem" height="2.625rem" />
    } @else {
      <p-floatlabel id="filter-user" variant="on">
      <p-iconfield>
        <p-autocomplete
          #userInput
          formControlName="user"
          [suggestions]="filteredUsers()"
          (completeMethod)="_searchUser($event)"
          [lazy]="true"
          [completeOnFocus]="true"
          dataKey="_id"
          optionLabel="fullname"
        />
        @if (userInput.value) {
          <p-inputicon
            class="cursor-pointer m-auto"
            (click)="filterForm.patchValue({user: null})"
          >
            <mat-icon>close</mat-icon>
          </p-inputicon>
        } @else {
          <div [style.width]="'28px'"></div>
        }
      </p-iconfield>
        <label>{{ 'internal.finances.transaction.user' | translate }}</label>
      </p-floatlabel>
    }

    @if (loadingEvents()) {
      <p-skeleton id="filter-event" width="13rem" height="2.625rem" />
    } @else {
      <p-floatlabel id="filter-event" variant="on">
      <p-iconfield>
        <p-autocomplete
          #eventInput
          formControlName="event"
          [suggestions]="filteredEvents()"
          (completeMethod)="_searchEvent($event)"
          [lazy]="true"
          [completeOnFocus]="true"
          dataKey="_id"
          optionLabel="name"
        />
        @if (eventInput.value) {
          <p-inputicon
            class="cursor-pointer m-auto"
            (click)="filterForm.patchValue({event: null})"
          >
            <mat-icon>close</mat-icon>
          </p-inputicon>
        } @else {
          <div [style.width]="'28px'"></div>
        }
      </p-iconfield>
        <label>{{ 'internal.finances.transaction.event' | translate }}</label>
      </p-floatlabel>
    }

    <p-selectbutton
      id="filter-income"
      [options]="[
        { label: 'internal.finances.transaction.income' | translate, value: true },
        { label: 'internal.finances.transaction.notincome' | translate, value: false },
      ]"
      formControlName="income"
      optionLabel="label"
      optionValue="value"
    />

    <p-selectbutton
      id="filter-pending"
      [options]="[
        { label: 'internal.finances.transaction.pending' | translate, value: true },
        { label: 'internal.finances.transaction.notpending' | translate, value: false },
      ]"
      formControlName="pending"
      optionLabel="label"
      optionValue="value"
    />

    @if (!isMobile()) {
      <div id="space" class="desktop"></div>
    }

    <button id="filter-reset" class="w-12 h-12 ml-auto" pButton [rounded]="true" [text]="true" (click)="filterForm.reset()">
      <mat-icon>close</mat-icon>
    </button>
  </form>

  <div class="flex flex-col gap-2 p-2">
    <finance-transaction-list-totalitem
      class="transaction-totalitem"
      [total]="totalAmount()"
      [totalPending]="totalAmountPending()">
    </finance-transaction-list-totalitem>

    @for (trans of filteredTransactions(); track trans; let index = $index) {
      @if (loadingTransactions()) {
        <p-skeleton height="6rem" class="ml-0.5 mr-0.5" />
      } @else {

        @if (index == 0 || differentSchoolyear(filteredTransactions()[index - 1], filteredTransactions()[index])) {
          <span class="text-2xl mt-6 ml-2 text-muted-color">{{transactionSchoolyear(trans)}} - {{transactionSchoolyear(trans) + 1}}</span>
          <div class="w-full h-1 bg-emphasis"></div>
        }

        <finance-transaction-list-item
          [users]="users()"
          [events]="events()"
          [transaction]="trans"
          [showEditButton]="api.hasPermission('edit_finances')"
          [showDeleteButton]="api.hasPermission('delete_finances')"
          (edit)="editTransaction(trans)"
          (delete)="deleteTransaction(trans)"
          class="transaction-item"
          [class.selected]="selectedTransactions().includes(trans._id)"
          (click)="selectTransaction(trans)"
        >
        </finance-transaction-list-item>
      }
    } @empty {
      <span class="text-3xl mt-8 text-neutral-500 text-center">
        {{ 'internal.finances.noTransactions' | translate }}
      </span>
    }
  </div>
</div>
